import { useMutation, useQuery } from "@apollo/client";
import {
  Avatar,
  Badge,
  Button,
  Card,
  Drawer,
  Group,
  LoadingOverlay,
  Modal,
  ScrollArea,
  Tabs,
  useMantineTheme,
} from "@mantine/core";
import { FiEdit, FiEye } from "react-icons/fi";
import { Edit, ManualGearbox, Trash } from "tabler-icons-react";
import EditIcon from "@mui/icons-material/Edit";
import { GET_MY_SUPPLIERS_Business, PRODUCT_DISCOUNT } from "apollo/queries";
import Controls from "components/controls/Controls";
import B2bTable from "components/reusable/b2bTable";
import { customLoader } from "components/utilities/loader";
import React, { useEffect } from "react";
import { useState } from "react";
import { showNotification } from "@mantine/notifications";
import { DEL_BUSINESS, DEL_DISCOUNT } from "apollo/mutuations";
import { DiscountAddModal } from "./addDiscount";
import { DiscountUpdateModal } from "./updateDiscount";
import { formatStatus } from "utiles/url";
import ActionButton from "components/controls/ActionButtonNew";

const ProductDiscount = ({ product }) => {
  const [size, setSize] = useState("10");
  const [openedDelete, setOpenedDelete] = useState(false);
  const [openedEdit, setOpenedEdit] = useState(false);
  const [openedDetail, setOpenedDetail] = useState(false);

  const [editId, setEditId] = useState();
  const [opened, setOpened] = useState(false);
  const [deleteID, setDeleteID] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [total, setTotal] = useState(0);

  const { data, loading, refetch } = useQuery(PRODUCT_DISCOUNT, {
    variables: {
      first: parseInt(size),
      page: activePage,
      product_id: product,
      ordered_by: [
        {
          column: "CREATED_AT",
          order: "DESC",
        },
      ],
    },
    onError(error) {
      showNotification({
        color: "red",
        title: "Error",
        message: error?.graphQLErrors?.[0]?.message || "Failed to Get Business",
      });
    },
  });

  const handlePageSizeChange = (newSize) => {
    setSize(newSize);
    setActivePage(1);
  };
  useEffect(() => {
    if (data) {
      setTotal(data.myProductDiscounts.paginatorInfo.lastPage);
    }
  }, [data, size]);
  useEffect(() => {
    refetch();
  }, []);

  const headerData = [
    {
      label: "Type",
      key: "discount_value_type",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{formatStatus(rowData.discount_value_type)}</span>;
      },
    },
    {
      label: "Value",
      key: "discount_value",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.discount_value}</span>;
      },
    },
    {
      label: "Product",
      key: "product",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{rowData.product.name}</span>;
      },
    },
    {
      label: "Start date",
      key: "start_date",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{new Date(rowData.start_date).toLocaleDateString()}</span>;
      },
    },
    {
      label: "End date",
      key: "end_date",
      sortable: false,
      searchable: true,
      render: (rowData) => {
        return <span>{new Date(rowData.end_date).toLocaleDateString()}</span>;
      },
    },
    {
      label: "Actions",
      key: "actions",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        return (
          <div style={{ display: "flex", gap: "6px" }}>
            <ActionButton label="Edit" onClick={() => handleEditUser(rowData)}>
              <EditIcon style={{ fontSize: "1rem" }} />
            </ActionButton>
            <ActionButton
              color="error"
              label="Delete"
              onClick={() => handleDelete(`${rowData.id}`)}
            >
              <Trash size={17} />
            </ActionButton>
          </div>
        );
      },
    },
  ];

  const handleDelete = (id) => {
    setOpenedDelete(true);
    setDeleteID(id);
  };

  const handleEditUser = (id) => {
    setOpenedEdit(true);
    setEditId(id);
  };

  const handleChange = (currentPage) => {
    setActivePage(currentPage);
  };

  const [confirmedSearch, setConfirmedSearch] = useState("");

  const optionsData = {
    actionLabel: "Add Discount",
    setAddModal: setOpened,
  };
  const theme = useMantineTheme();

  const [delCategory] = useMutation(DEL_DISCOUNT, {
    update(cache, { data: { deleteProductDiscount } }) {
      cache.updateQuery(
        {
          query: PRODUCT_DISCOUNT,
          variables: {
            first: parseInt(size),
            page: activePage,
            product_id: product,
            ordered_by: [
              {
                column: "CREATED_AT",
                order: "DESC",
              },
            ],
          },
        },
        (data) => {
          if (data.myProductDiscounts.data.length === 1) {
            setTotal(total - 1);
            setActivePage(activePage - 1);
          } else {
            return {
              myProductDiscounts: {
                data: [
                  ...data.myProductDiscounts.data.filter(
                    (category) => category.id !== deleteProductDiscount.id
                  ),
                ],
              },
            };
          }
        }
      );
    },
  });

  const deleteBusines = () => {
    delCategory({
      variables: { id: deleteID },
      onCompleted(data) {
        setOpenedDelete(false);
        setDeleteID(null);
        showNotification({
          color: "green",
          title: "Success",
          message: "Discount Deleted Successfully",
        });
      },
      onError(error) {
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message || "Failed to Delete discount",
        });
      },
    });
  };
  return loading ? (
    <LoadingOverlay
      visible={loading}
      color="blue"
      overlayBlur={2}
      loader={customLoader}
    />
  ) : (
    <div style={{ width: "98%", margin: "auto" }}>
      <Drawer
        opened={opened}
        onClose={() => setOpened(false)}
        title="Addding Discount"
        padding="xl"
        size="80%"
        position="bottom"
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
      >
        <DiscountAddModal
          total={total}
          product={product}
          size={size}
          activePage={activePage}
          setActivePage={setActivePage}
          setOpened={setOpened}
          refetch={refetch}
          setTotal={setTotal}
        />
      </Drawer>
      <Drawer
        opened={openedEdit}
        onClose={() => setOpenedEdit(false)}
        title="Editing Discount"
        padding="xl"
        size="80%"
        position="bottom"
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
      >
        <DiscountUpdateModal
          setOpened={setOpenedEdit}
          productDiscount={editId}
        />
      </Drawer>
      <Modal
        opened={openedDelete}
        onClose={() => setOpenedDelete(false)}
        title="Warning"
        centered
      >
        <p>Are you sure do you want todelete this discount?</p>
        <Group position="right">
          <Button onClick={() => deleteBusines()} color="red">
            Delete
          </Button>
        </Group>
      </Modal>
      <Card shadow="sm" p="lg">
        <ScrollArea>
          <B2bTable
            total={total}
            activePage={activePage}
            handleChange={handleChange}
            header={headerData}
            searchInput={false}
            searchValue={confirmedSearch}
            onSearchChange={setConfirmedSearch}
            loading={loading}
            optionsData={optionsData}
            layout={{ minWidth: 700 }}
            data={data ? data.myProductDiscounts.data : []}
            //  size={size}
            handlePageSizeChange={handlePageSizeChange}
          />
        </ScrollArea>
      </Card>
    </div>
  );
};

export default ProductDiscount;
